import { exhaustMap, filter, map } from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'
import { normalizeToSchema } from 'src/app/shared/normalization/normalization'
import { normalizationActions } from 'src/app/shared/normalization/normalization.actions'
import { ResourceEffects } from 'src/app/shared/resource-effects'

import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { Location } from './location'
import { locationActions } from './location.actions'
import * as fromLocation from './location.reducer'
import { LocationService } from './location.service'

@Injectable()
export class LocationEffects extends ResourceEffects<Location> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    public locationService: LocationService
  ) {
    super(fromLocation.FEATURE_NAME, locationService, locationActions, actions$)
  }
}
